/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useMemo } from 'react';
import { Button } from './Button';
export var SlotSections = function (_a) {
    var className = _a.className, slots = _a.slots, value = _a.value, onChange = _a.onChange;
    var morning = useMemo(function () { return slots.filter(function (slot) { return slot < '12:00'; }); }, [
        slots,
    ]);
    var lunchtime = useMemo(function () { return slots.filter(function (slot) { return slot >= '12:00' && slot < '14:00'; }); }, [slots]);
    var afternoon = useMemo(function () { return slots.filter(function (slot) { return slot >= '14:00' && slot < '17:00'; }); }, [slots]);
    var evening = useMemo(function () { return slots.filter(function (slot) { return slot >= '17:00'; }); }, [
        slots,
    ]);
    return (jsx("div", { className: className },
        morning.length ? (jsx(SlotSection, { slots: morning, value: value, onChange: onChange, label: "Morning" })) : null,
        lunchtime.length ? (jsx(SlotSection, { slots: lunchtime, value: value, onChange: onChange, label: "Lunch time" })) : null,
        afternoon.length ? (jsx(SlotSection, { slots: afternoon, value: value, onChange: onChange, label: "Afternoon" })) : null,
        evening.length ? (jsx(SlotSection, { slots: evening, value: value, onChange: onChange, label: "Evening" })) : null));
};
var SlotSection = function (_a) {
    var slots = _a.slots, onChange = _a.onChange, label = _a.label;
    return (jsx("div", { sx: { mb: 3 } },
        jsx("div", { sx: { fontSize: 1, color: 'muted', mb: 2, textTransform: 'uppercase' } }, label),
        slots.map(function (slot) {
            return (jsx(Button, { key: slot, size: "sm", variant: "filledLightGrey", sx: { fontSize: 1, m: 1 }, onClick: function () {
                    onChange(slot);
                } }, slot));
        })));
};
//# sourceMappingURL=SlotSections.js.map